import React, { useEffect, useState } from "react";
import { CourseType } from "../types";
import { text } from "../text";
import { utils } from "../utils";
import { hooks } from "../hooks";
import { theme } from "../constants";
import { course as elements } from "../course";
import { CourseInWishlist } from "./CourseInWishlist";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules"; // ✅ Swiper pagination module
import "swiper/css";
import "swiper/css/pagination"; // ✅ Swiper dots style
import { BookingSvg } from "../assets/svg/Booking";
import fallBackImg from "../assets/nestfin/No_image_Found.png";
import { callService } from "../customHook/callService";
import {
  formatIndianNumber,
  leadIdFromStorage,
  webCallLead,
} from "../environment";
import { ImageWithLoader } from "./ImageWithLoader";
import useApi from "../customHook/useApi";
import { Navigate } from "react-router-dom";
import ContactOwnerModal from "../components/ContactOwnerModal";

type Feature = {
  feature_id: number;
  feature_name: string;
  icon: string;
};

type Photo = {
  photo_id: number;
  photo_path: string;
};

type Property = {
  property_id: string;
  property_name: string;
  address: string;
  locality_id: string;
  locality_name: string | null;
  city_id: string;
  city_name: string;
  pincode: string;
  state: string;
  features: Feature[] | null;
  contact_phone: string | null;
  // photos: any; // Replace `any` if photo type is known
  photos: Photo[] | null;
  minimum_rent: number;
  gender_allowed: string;
  category: string;
  is_meal_provided?: string | null;
};

type Props = {
  isLast?: boolean;
  // course: CourseType;
  course: Property;
  section: "top rated";
  index: number;
};

const buttonTagStyle = {
  // backgroundColor: "var(--primary-color)",
  backgroundColor: "var(--secondary-color)",
  padding: "5px 9px",
  borderRadius: "5px",
  color: "white",
  cursor: "pointer",
  fontSize: "9px",
  letterSpacing: "1px",
};

export const SerachResultCard: React.FC<Props> = ({
  course,
  section,
  isLast,
  index,
}) => {
  const navigate = hooks.useNavigate();
  const fallbackImage = fallBackImg;
  const [isLoading, setIsLoading] = useState(false);

  // --- preferences ---
  const [selectedPropertyId, setSelectedPropertyId] = useState<any>(null);
  const [isShowContactModal, setIsShowContactModal] = useState<boolean>(false);

  const [isModalOpen2, setisModalOpen2] = useState(false);

  // fallback if photos is null, undefined, or empty
  const imagesToShow =
    course.photos && course.photos.length > 0 ? course.photos : [fallbackImage];

  // console.log("🔍 Course Debug - SearchResultCard:", course);

  const handleReuestOwnerCall = (course: any) => {
    // console.log(leadIdFromStorage, "handleReuestOwnerCall", course)
    const propertyId = course?.property_id;
    const leadid = localStorage.getItem("lead_profile_id") ?? "";
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken && !leadid) {
      navigate("/onbording3");
      return;
    }

    if (propertyId) {
      setIsLoading(true);
      callService("CONTACT_OWNER", [
        {
          param: "PROPERTY_ID",
          value: propertyId,
        },
      ])
        .then((res) => {
          // console.log("✅ VIEWED_PROPERTIES response:", res);
          setisModalOpen2(true);
        })
        .catch((err) => {
          console.error("❌ VIEWED_PROPERTIES API failed:", err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  // Web Call Api
  const {
    data: WebCallApiData,
    loading: WebCallApiLoading,
    callApi: webCallPost,
  } = useApi(webCallLead, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // const handleWebCallLead = async (propertyId: any, prefs: any) => {
  const handleWebCallLead = async (prefs: any) => {
    if (!selectedPropertyId) return;
    const leadId = localStorage.getItem("lead_profile_id") ?? "";
    const payload = {
      property_id: selectedPropertyId,
      lead_id: leadId,
      ...prefs,
      // lead_id: leadIdFromStorage,
    };
    try {
      const response = await webCallPost(payload);
      // console.log("API Response:", response);
      if (response.success) {
        setIsShowContactModal(false);
        setSelectedPropertyId(null);
        setisModalOpen2(true);
      }
    } catch (error) {
      console.error("API call failed:", error);
    }
  };

  return (
    <>
      <div className="container">
        <div className="sperate-card-container">
          <div
            onClick={() => {
              const localitySlug =
                course?.locality_name?.toLowerCase()?.replace(/\s+/g, "-") ||
                "locality";
              const citySlug =
                course?.city_name?.toLowerCase()?.replace(/\s+/g, "-") ||
                "city";
              const propertySlug =
                course?.property_name?.toLowerCase()?.replace(/\s+/g, "-") ||
                "property";
              const propertyId = `?id=${btoa(course?.property_id || "")}`;
              const customUrl = `/rooms/${localitySlug}/${citySlug}/${propertySlug}/${propertyId}`;
              // console.log(customUrl, "customUrl......");
              navigate(customUrl, {
                state: { course, property_id: course.property_id },
              });
            }}
            style={{ cursor: "pointer" }}
          >
            <div className="sperate-card-container_img">
              <div className="SwiperContainerImg">
                {/* <Swiper
                  key={`${course.property_id}-${index}`}
                  modules={[Pagination, Autoplay]}
                  spaceBetween={10}
                  slidesPerView={1}
                  pagination={{ clickable: true }}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  className="swiperSearchResult"
                >
                  {(course?.photos && course?.photos.length > 0
                    ? course.photos.map((photoObj) => photoObj.photo_path)
                    : [fallBackImg]
                  ).map((image, idx) => (
                    <SwiperSlide key={idx}>
                      <img
                        src={image}
                        alt={`Preview ${idx + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: 0,
                        }}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper> */}

                <Swiper
                  key={`${course.property_id}-${index}`}
                  modules={[Pagination, Autoplay]}
                  spaceBetween={10}
                  slidesPerView={1}
                  pagination={{ clickable: true }}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  className="swiperSearchResult"
                >
                  {(course?.photos && course?.photos.length > 0
                    ? course.photos.map((photoObj) => photoObj.photo_path)
                    : [fallBackImg]
                  ).map((image, idx) => (
                    <SwiperSlide key={idx}>
                      <ImageWithLoader
                        src={image}
                        alt={`Preview ${idx + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>

              {/* start Content of card */}
              <div
                style={{
                  width: "100%",
                  position: "relative",
                  borderRadius: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    marginLeft: 10,
                    padding: "22px 10px",
                  }}
                >
                  <div>
                    <p
                      style={{ margin: 0, marginTop: "5px", fontSize: "14px" }}
                    >
                      Starting from
                    </p>
                    <text.T16
                      style={{
                        color: "var(--secondary-color)",
                        ...theme.fonts.Lato_700Bold,
                      }}
                    >
                      {/* ₹{course?.minimum_rent} / month */}₹
                      {formatIndianNumber(course?.minimum_rent)} / month
                    </text.T16>

                    <div
                      style={{
                        paddingBottom: "8px",
                        fontSize: "18px",
                        marginTop: "5px",
                      }}
                    >
                      {course?.property_name}
                    </div>
                    <p className="addressCard">
                      {/* {`${course?.locality_name}, ${course?.city_name},  ${course?.pincode}`} */}
                      {[
                        course?.locality_name,
                        course?.city_name,
                        course?.pincode,
                      ]
                        .filter(Boolean)
                        .join(", ")}
                    </p>

                    <div className="pg-card-features">
                      {(course?.features ?? []).slice(0, 3).map((feature) => (
                        <span key={feature.feature_id} className="feature-tag">
                          {feature.feature_name}
                        </span>
                      ))}
                      {course?.features && course?.features.length > 3 && (
                        <span
                          className="feature-tag more-tag"
                          // onClick={(e) => {
                          //   e.stopPropagation();
                          //   navigate("/course-details", { state: { course } });
                          // }}
                        >
                          +{course.features.length - 3} more
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                {/*  button Category and Prefrence  */}
                <div
                  style={{
                    marginTop: "0.3rem",
                    position: "absolute",
                    top: "4px",
                    right: "10px",
                    display: "flex",
                    gap: "6px", // space between buttons
                    fontWeight: "bold",
                  }}
                  onClick={() => {
                    const localitySlug =
                      course?.locality_name
                        ?.toLowerCase()
                        ?.replace(/\s+/g, "-") || "locality";
                    const citySlug =
                      course?.city_name?.toLowerCase()?.replace(/\s+/g, "-") ||
                      "city";
                    const propertySlug =
                      course?.property_name
                        ?.toLowerCase()
                        ?.replace(/\s+/g, "-") || "property";

                    const customUrl = `/rooms/${localitySlug}/${citySlug}/${propertySlug}`;

                    // console.log(customUrl, "customUrl......");
                    navigate(customUrl, {
                      state: { course, property_id: course.property_id },
                    });
                  }}
                >
                  {!!course?.category && (
                    <button style={buttonTagStyle}>
                      {course?.category?.toUpperCase()}
                    </button>
                  )}

                  {!!course?.gender_allowed && (
                    <button style={buttonTagStyle}>
                      {course?.gender_allowed?.toUpperCase()}
                    </button>
                  )}

                  <button style={buttonTagStyle}>
                    {(!!course?.is_meal_provided &&
                      course?.is_meal_provided?.toLowerCase()) == "yes"
                      ? "MEAL"
                      : "NO MEAL"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              marginBottom: "15px",
              gap: 10,
              padding: "0 14px 12px",
            }}
          >
            <button
              className="ctaBtn2"
              style={{
                flex: 1,
                padding: "12px 0",
                border: "none",
                borderRadius: "8px",
                backgroundColor: isLoading ? "#ccc" : "Green",
                color: "#fff",
                cursor: isLoading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 600,
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                transition: "background-color 0.3s ease",
                fontSize: "14px",
                opacity: isLoading ? 0.7 : 1,
              }}
              // onClick={() => !isLoading && handleReuestOwnerCall(course)}
              onClick={() => {
                const leadId = localStorage.getItem("lead_profile_id") ?? "";
                if (!leadId) {
                  // console.log("clicked contact owner");
                  navigate("/onbording3", { replace: true });
                  return null;
                }
                setIsShowContactModal(true);
                setSelectedPropertyId(course?.property_id);
                // handleWebCallLead(course?.property_id);
              }}
              disabled={isLoading}
            >
              Contact Owner
            </button>

            <button
              className="ctaBtn1"
              style={{
                flex: 1,
                padding: "12px 0",
                border: "none",
                borderRadius: "8px",
                // backgroundColor: "orange",
                // color: "black",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 600,
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                transition: "background-color 0.3s ease",
                fontSize: "14px",
              }}
              onClick={() => {
                const propertyId = course?.property_id;
                const propertyName = course?.property_name;
                if (propertyId) localStorage.setItem("property_id", propertyId);
                if (propertyName)
                  localStorage.setItem("property_name", propertyName);

                // navigate("/room-type", {
                //   // replace: true,
                //   state: {
                //     property_id: propertyId,
                //     property_name: propertyName,
                //   },
                // });

                navigate("/room-type", {
                  state: {
                    propertyData: course,
                  },
                });
              }}
            >
              Book Now
            </button>
          </div>
        </div>
      </div>

      {isShowContactModal && (
        <ContactOwnerModal
          isSubmitting={WebCallApiLoading}
          setIsOpen={setIsShowContactModal}
          handleSubmit={(prefs) => handleWebCallLead(prefs)}
        />
      )}

      {isModalOpen2 && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2></h2>
            <p></p>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                alt="Success"
                src={require("../assets/nestfin/Nestfin_logo.png")}
                style={{ width: "50%", height: "auto", marginBottom: 10 }}
              />
              <img
                alt="Success"
                // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
                src={require("../assets/other/checked.png")}
                style={{ width: "30%", height: "auto", margin: "30px 0" }}
              />
              <h2 style={{ textAlign: "center", marginBottom: 10 }}>
                Request Sent Successfully
              </h2>
              <text.T16
                style={{
                  whiteSpace: "pre-line",
                  textAlign: "center",
                  marginBottom: 24,
                }}
              >
                The owner will get in touch with you shortly.
              </text.T16>
              <div
                onClick={() => {
                  setisModalOpen2(false);
                }}
                style={{
                  width: "100%",
                  color: theme.colors.white,
                  height: 40,
                  textAlign: "center",
                  fontSize: 14,
                  borderRadius: 10,
                  userSelect: "none",
                  cursor: "pointer",
                  textTransform: "capitalize",
                  background: "#000000d1",
                  fontFamily: "Lato-Bold",
                  marginTop: 12, // optional spacing
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Continue
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// 07-06-2025 code
// import React from 'react';
// import { CourseType } from '../types';
// import { text } from '../text';
// import { utils } from '../utils';
// import { hooks } from '../hooks';
// import { theme } from '../constants';
// import { course as elements } from '../course';
// import { CourseInWishlist } from './CourseInWishlist';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Pagination, Autoplay } from 'swiper/modules'; // ✅ Swiper pagination module
// import 'swiper/css';
// import 'swiper/css/pagination'; // ✅ Swiper dots style

// type Props = {
//     isLast?: boolean;
//     course: CourseType;
//     section: 'top rated';
//     index: number;
// };

// export const SerachResultCard: React.FC<Props> = ({
//     course,
//     section,
//     isLast,
//     index
// }) => {
//     const navigate = hooks.useNavigate();

//     return (
//         <div className='container' >
//             <div
//                 className='sperate-card-container'
//                 onClick={() => navigate('/course-details', { state: { course } })}

//             >
//                 <div className='sperate-card-container_img' >
//                     <div className='SwiperContainerImg'>

//                         <Swiper
//                             key={`${course.id}-${index}`}
//                             modules={[Pagination, Autoplay]}
//                             spaceBetween={10}
//                             slidesPerView={1}
//                             pagination={{ clickable: true }}
//                             autoplay={{
//                                 delay: 3000,
//                                 disableOnInteraction: false, // Keeps autoplay after user interaction
//                             }}
//                             className='swiperSearchResult'
//                         // style={{ width: '100%', height: 150, borderRadius: 10 }}

//                         >
//                             {(course.previewImages || [course.preview_90x90]).map((image, idx) => (
//                                 <SwiperSlide key={idx}>
//                                     <img
//                                         src={image}
//                                         alt={`Preview ${idx + 1}`}
//                                         style={{
//                                             width: '100%',
//                                             height: '100%',
//                                             objectFit: 'cover',
//                                             borderRadius: 10,
//                                         }}
//                                     />
//                                 </SwiperSlide>
//                             ))}
//                         </Swiper>

//                     </div>

//                     <div style={{ width: '100%', position: "relative" }}>
//                         <div style={{ display: 'flex', marginLeft: 10, }}>
//                             <div>
//                                 <p className='typeOfRoom' >Semi Furnished</p>
//                                 <text.T16 style={{ color: "#7065F0", ...theme.fonts.Lato_700Bold }}>
//                                     ₹{course.price}/Month
//                                     {/* ₹5000/Month */}
//                                 </text.T16>
//                                 <elements.CourseName
//                                     course={course}
//                                     numberOfLines={1}
//                                     shortName={true}
//                                 />
//                                 <p className='addressCard' >
//                                     Model Town, New Delhi
//                                 </p>
//                                 {/* <elements.areaDescription course={course} /> */}
//                             </div>
//                         </div>
//                         <elements.CourseRating
//                             course={course}
//                             containerStyle={{
//                                 margin: 2,
//                                 position: 'absolute',
//                                 top: 30,
//                                 right: 7,
//                             }}
//                         />
//                         <CourseInWishlist
//                             course={course}
//                             size={20}
//                             style={{ position: 'absolute', right: 17, top: 8 }}
//                         />
//                     </div>
//                 </div>

//                 <div className="info-row">
//                     <div className="info-item highlight">
//                         <p className="label">Security Deposit</p>
//                         <p className="value">₹ 5,000</p>
//                     </div>
//                     <div className="info-item">
//                         <p className="label">Agreement</p>
//                         <p className="value">3 Months</p>
//                     </div>
//                     <div className="info-item">
//                         <p className="label">Locking Period</p>
//                         <p className="value">4 Months</p>
//                     </div>
//                     <div className="info-item">
//                         <p className="label">Notice Period</p>
//                         <p className="value">4 Months</p>
//                     </div>
//                 </div>

//             </div>
//         </div >
//     );
// };

// Working Code

// import React from 'react';
// import { CourseType } from '../types';
// import { text } from '../text';
// import { utils } from '../utils';
// import { hooks } from '../hooks';
// import { theme } from '../constants';
// import { course as elements } from '../course';
// import { CourseInWishlist } from './CourseInWishlist';

// type Props = {
//     isLast?: boolean;
//     course: CourseType;
//     section: 'top rated';
// };

// export const SerachResultCard: React.FC<Props> = ({
//     course,
//     section,
//     isLast,
// }) => {
//     const navigate = hooks.useNavigate();

//     return (
//         <div className='container' >
//             <div
//                 className='sperate-card-container'
//                 onClick={() => navigate('/course-details', { state: { course } })}

//             >

//                 <div style={{ display: "flex" }}>
//                     <div
//                         style={{
//                             minWidth: 140,
//                             minHeight: 110,
//                             marginRight: 12,
//                             position: 'relative',
//                         }}
//                     >

//                         <img
//                             src={course.preview_90x90}
//                             style={{
//                                 width: '100%',
//                                 height: '100%',
//                                 borderRadius: 10,
//                                 position: 'absolute',
//                                 inset: 0,
//                             }}
//                         />
//                         <elements.CourseRating
//                             course={course}
//                             containerStyle={{
//                                 margin: 2,
//                                 position: 'absolute',
//                                 bottom: 0,
//                                 left: 0,
//                             }}
//                         />
//                     </div>
//                     <div style={{ width: '100%', position: 'relative' }}>
//                         <div style={{ display: 'flex', marginLeft: 10 }}>
//                             <div>
//                                 <p className='typeOfRoom' >Semi Furnished</p>
//                                 <text.T16 style={{ color: "#7065F0", ...theme.fonts.Lato_700Bold }}>
//                                     ₹{course.price}/Month
//                                     {/* ₹5000/Month */}
//                                 </text.T16>
//                                 <elements.CourseName
//                                     course={course}
//                                     numberOfLines={1}
//                                     shortName={true}
//                                 />
//                                 <text.T16 style={{ color: "#000" }}>
//                                     Model Town, New Delhi
//                                 </text.T16>
//                                 {/* <elements.areaDescription course={course} /> */}
//                             </div>
//                         </div>
//                         <CourseInWishlist
//                             course={course}
//                             size={20}
//                             style={{ position: 'absolute', left: -39, top: 8 }}
//                         />
//                     </div>
//                 </div>

//                 <div className="info-row">
//                     <div className="info-item highlight">
//                         <p className="label">Security Deposit</p>
//                         <p className="value">₹ 5,000</p>
//                     </div>
//                     <div className="info-item">
//                         <p className="label">Agreement</p>
//                         <p className="value">3 Months</p>
//                     </div>
//                     <div className="info-item">
//                         <p className="label">Locking Period</p>
//                         <p className="value">4 Months</p>
//                     </div>
//                     <div className="info-item">
//                         <p className="label">Notice Period</p>
//                         <p className="value">4 Months</p>
//                     </div>
//                 </div>

//             </div>
//         </div >
//     );
// };

// ****************OLD CODE **********************************

// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { utils } from '../utils';
// import { hooks } from '../hooks';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// import { CourseType } from '../types';
// import { course as elements } from '../course';

// type Props = {
//     isLast?: boolean;
//     course: CourseType;
//     status?: 'ongoing' | 'completed';
//     section: 'top rated' | 'category list' | 'my courses' | 'Recommanded For you';
// };

// export const SerachResultCard: React.FC<Props> = ({
//     course,
//     section,
//     isLast,
//     status,
// }) => {
//     const navigate = hooks.useNavigate();

//     if (section === 'top rated') {
//         return (
//             <div
//                 style={{
//                     width: '100%',
//                     padding: '0 20px',
//                     cursor: 'pointer',
//                     userSelect: 'none',
//                     ...utils.rowCenter(),
//                     marginBottom: isLast ? 0 : 10,
//                     paddingBottom: isLast ? 0 : 10,
//                     borderBottomWidth: isLast ? 0 : 1,
//                     borderBottomStyle: isLast ? 'none' : 'solid',
//                     borderBottomColor: `rgba(59, 89, 153, 0.1)`,
//                 }}
//                 onClick={() => navigate('/course-details', { state: { course } })}
//             >
//                 <div
//                     style={{
//                         minWidth: 140,
//                         minHeight: 110,
//                         marginRight: 12,
//                         position: 'relative',
//                     }}
//                 >
//                     <img
//                         src={course.preview_90x90}
//                         style={{
//                             width: '100%',
//                             height: '100%',
//                             borderRadius: 10,
//                             position: 'absolute',
//                             inset: 0,
//                         }}
//                     />
//                     <elements.CourseRating
//                         course={course}
//                         containerStyle={{
//                             margin: 2,
//                             position: 'absolute',
//                             bottom: 0,
//                             left: 0,
//                         }}
//                     />
//                 </div>
//                 <div style={{ width: '100%', position: 'relative' }}>
//                     <div style={{ display: 'flex', marginLeft: 10 }}>
//                         <div>
//                             {/* {course.oldPrice && (
//                 <span
//                   style={{
//                     marginRight: 6,
//                     color: theme.colors.secondaryTextColor,
//                     textDecorationLine: 'line-through',
//                     ...theme.fonts.Lato_700Bold,
//                     fontSize: 18,
//                     lineHeight: 1.5,
//                     marginTop: 3,
//                   }}
//                 >
//                   ${course.oldPrice.toFixed(2)}
//                 </span>
//               )} */}
//                             <text.T16 style={{ color: "#7065F0", ...theme.fonts.Lato_700Bold, }}>
//                                 ${course.price.toFixed(2)}/Month
//                             </text.T16>
//                             <elements.CourseName
//                                 course={course}
//                                 numberOfLines={1}
//                                 shortName={true}
//                             />
//                             <text.T16 style={{ color: "#000" }}>
//                                 London University
//                             </text.T16>
//                             <elements.areaDescription
//                                 course={course}
//                             // numberOfLines={1}
//                             // shortName={true}
//                             />

//                         </div>
//                     </div>
//                     {/* <div style={{width: 202, marginRight: 30}}>
//             <text.H6
//               numberOfLines={2}
//               style={{marginBottom: 10}}
//             >
//               {course.name}
//             </text.H6>
//           </div> */}
//                     {/* <div style={{...utils.rowCenter()}}>
//             <svg.ClockSvg color={theme.colors.secondaryTextColor} />
//             <text.T14
//               style={{
//                 marginLeft: 6,
//                 marginRight: 'auto',
//                 color: theme.colors.secondaryTextColor,
//               }}
//             >
//               {course.duration}
//             </text.T14>
//             <elements.CoursePrice course={course} />
//           </div> */}
//                     <elements.CourseInWishlist
//                         course={course}
//                         size={20}
//                         style={{ position: 'absolute', right: 0, top: 0 }}
//                     />
//                 </div>
//             </div>
//         );
//     }

//     if (section === 'category list') {
//         return (
//             <div
//                 style={{
//                     width: '100%',
//                     padding: '0 20px',
//                     cursor: 'pointer',
//                     userSelect: 'none',
//                     ...utils.rowCenter(),
//                     marginBottom: isLast ? 0 : 10,
//                     paddingBottom: isLast ? 0 : 10,
//                     borderBottomWidth: isLast ? 0 : 1,
//                     borderBottomStyle: isLast ? 'none' : 'solid',
//                     borderBottomColor: `rgba(59, 89, 153, 0.1)`,
//                 }}
//                 onClick={() => navigate('/course-details', { state: { course } })}
//             >
//                 <div
//                     style={{
//                         minWidth: 90,
//                         minHeight: 90,
//                         marginRight: 12,
//                         position: 'relative',
//                     }}
//                 >
//                     <img
//                         src={course.preview_90x90}
//                         style={{
//                             width: '100%',
//                             height: '100%',
//                             borderRadius: 10,
//                             position: 'absolute',
//                             inset: 0,
//                         }}
//                     />
//                     <elements.CourseRating
//                         course={course}
//                         containerStyle={{
//                             margin: 2,
//                             position: 'absolute',
//                             bottom: 0,
//                             left: 0,
//                         }}
//                     />
//                 </div>
//                 <div style={{ width: '100%', position: 'relative' }}>
//                     <div style={{ display: 'flex', marginLeft: 10 }}>
//                         <div>
//                             {/* {course.oldPrice && (
//                 <span
//                   style={{
//                     marginRight: 6,
//                     color: theme.colors.secondaryTextColor,
//                     textDecorationLine: 'line-through',
//                     ...theme.fonts.Lato_700Bold,
//                     fontSize: 18,
//                     lineHeight: 1.5,
//                     marginTop: 3,
//                   }}
//                 >
//                   ${course.oldPrice.toFixed(2)}
//                 </span>
//               )} */}
//                             <text.T16 style={{ color: "#7065F0", ...theme.fonts.Lato_700Bold, }}>
//                                 ${course.price.toFixed(2)}/Month
//                             </text.T16>
//                             <elements.CourseName
//                                 course={course}
//                                 numberOfLines={1}
//                                 shortName={true}
//                             />
//                             <text.T16 style={{ color: "#000" }}>
//                                 London University
//                             </text.T16>
//                             <elements.areaDescription
//                                 course={course}
//                             // numberOfLines={1}
//                             // shortName={true}
//                             />
//                             <elements.CourseInWishlist
//                                 course={course}
//                                 size={20}
//                                 style={{ position: 'absolute', right: 0, top: 0 }}
//                             />
//                         </div>
//                     </div>
//                     {/* <div style={{ width: 202, marginRight: 30 }}>
//             <text.H6
//               numberOfLines={2}
//               style={{ marginBottom: 10 }}
//             >
//               {course.name}
//             </text.H6>
//           </div>
//           <div style={{ ...utils.rowCenter() }}>
//             <svg.ClockSvg />
//             <text.T14 style={{ marginLeft: 6, marginRight: 'auto' }}>
//               {course.duration}
//             </text.T14>
//             <elements.CoursePrice course={course} />
//           </div>
//          */}
//                 </div>
//             </div>
//         );
//     }

//     if (section === 'my courses') {
//         return (
//             <button
//                 className='custom-block'
//                 style={{
//                     width: '48%',
//                     borderRadius: 10,
//                     marginBottom: 15,
//                 }}
//             >
//                 <div
//                     style={{ height: 96, position: 'relative' }}
//                     onClick={() => navigate('/course-details', { state: { course } })}
//                 >
//                     <img
//                         src={course.preview_90x90}
//                         alt='course'
//                         style={{
//                             height: '100%',
//                             borderTopLeftRadius: 10,
//                             borderTopRightRadius: 10,
//                             objectFit: 'cover',
//                         }}
//                     />
//                     <div
//                         style={{
//                             position: 'absolute',
//                             top: 0,
//                             right: 0,
//                             width: '100%',
//                             height: '100%',
//                             backgroundColor: 'rgba(0, 0, 0, 0.1)',
//                             borderTopRightRadius: 10,
//                             borderTopLeftRadius: 10,
//                         }}
//                     />
//                     <svg.PlayBtnSvg
//                         style={{
//                             position: 'absolute',
//                             top: '50%',
//                             left: '50%',
//                             transform: 'translate(-50%, -50%)',
//                         }}
//                     />
//                 </div>
//                 <div style={{ padding: '11px 14px 14px 14px' }}>
//                     <text.T14
//                         numberOfLines={2}
//                         style={{ color: theme.colors.mainColor }}
//                     >
//                         {course.name}
//                     </text.T14>
//                     {status === 'ongoing' && (
//                         <div>
//                             <div
//                                 style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     marginTop: 8,
//                                     justifyContent: 'space-between',
//                                 }}
//                             >
//                                 <text.T12
//                                     style={{
//                                         color: theme.colors.secondaryTextColor,
//                                         ...theme.fonts.Lato_400Regular,
//                                     }}
//                                 >
//                                     56%
//                                 </text.T12>
//                                 <div style={{ ...utils.rowCenter({ gap: 3 }) }}>
//                                     <svg.StarSvg />
//                                     <text.T10
//                                         style={{
//                                             ...theme.fonts.Lato_700Bold,
//                                             color: theme.colors.mainColor,
//                                         }}
//                                     >
//                                         {course.rating}
//                                     </text.T10>
//                                 </div>
//                             </div>
//                             <div
//                                 style={{
//                                     width: '100%',
//                                     height: 3,
//                                     backgroundColor: '#C3D9FD',
//                                     borderRadius: 3,
//                                 }}
//                             >
//                                 <div
//                                     style={{
//                                         width: '56%',
//                                         height: 3,
//                                         backgroundColor: '#55ACEE',
//                                         borderRadius: 3,
//                                     }}
//                                 />
//                             </div>
//                         </div>
//                     )}
//                     {status === 'completed' && (
//                         <button
//                             style={{
//                                 width: '100%',
//                                 border: `1px solid ${theme.colors.secondaryTextColor}`,
//                                 borderRadius: 5,
//                                 marginTop: 6,
//                                 padding: '4px 0px',
//                                 ...utils.flexCenter(),
//                             }}
//                             onClick={() => navigate('/course-completed')}
//                         // onClick={() => navigate('/course-completed-certificate')}
//                         >
//                             <text.T10 style={{ color: theme.colors.mainColor }}>
//                                 View certificate
//                             </text.T10>
//                         </button>
//                     )}
//                 </div>
//             </button>
//         );
//     }

//     return null;
// };
